import { TYPES } from "./types";
import { agentService } from "../services";

export const getAgents = (query) => async (dispatch) => {
  try {
    const result = await agentService.getAgents(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_AGENTS_SUCCESS,
        payload: { data },
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_AGENTS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateAgent = (data) => async (dispatch) => {
  try {
    const response = await agentService.updateAgent(data);
    dispatch({
      type: TYPES.ACTION_UPDATE_AGENT_SUCCESS,
      payload: response.data
    });
    return response;
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_UPDATE_AGENT_FAIL,
      payload: error
    });
    throw error;
  }
};

export const agentAction = {
  getAgents,
  updateAgent
}; 